import { render, staticRenderFns } from "./PointSelector.vue?vue&type=template&id=18a17dde&scoped=true"
import script from "./PointSelector.vue?vue&type=script&lang=ts"
export * from "./PointSelector.vue?vue&type=script&lang=ts"
import style0 from "./PointSelector.vue?vue&type=style&index=0&id=18a17dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a17dde",
  null
  
)

export default component.exports